<div class="risk-trends-card">
    <div class="risk-trends-card-header">
        <div>
            <div class="risk-trends-card-title">{{ 'new_entries.user_registration_trends' | translate }}</div>
            <div class="risk-trends-card-subtitle">
                {{ 'new_entries.monthly_educator_and_student_registrations_by_platform' | translate }}
            </div>
        </div>
        <div class="risk-trends-controls">
            <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <label>{{ 'new_entries.filter_by' | translate }}</label>
                <select class="risk-dropdown" [(ngModel)]="selectedPlatform" (change)="onPlatformChange()">
                    <option *ngFor="let p of platforms" [value]="p.value">{{ p.label }}</option>
                </select>
            </div>
            <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <label>{{ 'new_entries.year' | translate }}</label>
                <select class="risk-year-selector" [(ngModel)]="selectedYear" (change)="onYearChange()">
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="risk-trends-chart-placeholder" style="background: none; padding: 0;">
        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
            [yaxis]="chartOptions.yaxis" [plotOptions]="chartOptions.plotOptions" [colors]="chartOptions.colors"
            [legend]="chartOptions.legend" [dataLabels]="chartOptions.dataLabels" [grid]="chartOptions.grid"
            [stroke]="chartOptions.stroke" style="width: 100%; min-width: 0;"></apx-chart>

    </div>
</div>